// extracted by mini-css-extract-plugin
export default {"root":"VMatchTimelineEventSection_root_2l_da","title":"VMatchTimelineEventSection_title_2n4o4","score":"VMatchTimelineEventSection_score_aNRMm"};